import { Container, Row, Col, Image } from 'react-bootstrap';
import Footer from './components/Footer';

export default function Venue() {

  return (
    <>
      <section id="hero" className="hero hero-background  position-relative">
        <Container >
          <Row className="align-items-center">
              <Col md={8} lg={6} className=''>
                <h1 className="display-3 fw-bold text-white">Venue & Travel</h1>
              </Col>
            </Row>
        </Container>
      </section>

      <Container className='py-5'>
        <Row>
          <Col lg={{ span: 8, offset: 2 }} className='pb-5'>
            <h2 className='h1 mb-4 purple-h'>Why Bled?</h2>
            <p>Bled is <highlight>one of Europe’s most enchanting alpine destinations.</highlight> Nestled at the foothills of the Julian Alps and framed by a sparkling lake and island church, it’s the perfect setting for mixing business with inspiration. The region offers easy access to outdoor pursuits, such as hiking, cycling, boating, or sampling the legendary Bled cream cake, providing memorable experiences alongside a productive conference.</p>
          </Col>
          <Col md="12">
            <div className="position-relative ps-4 pt-4">
              <Image src='images/venue-8.jpg' className="img-fluid " data-aos="fade-up" data-aos-delay="50" />
              <div className="svg-overlay position-absolute"><Image src="images/bpp-02-h.svg" data-aos="fade-right" data-aos-delay="250" width={'400px'}/></div>
            </div>
          </Col>
        </Row>
      </Container>

      <Container className='py-5'>
        <Row>
          <Col lg={{ span: 8, offset: 2 }} className='pb-5'>
            <h2 className='h1 mb-4 purple-h'>Conference Venue: Hotel Kompas</h2>
            <p>Located on a <highlight>picturesque hill overlooking Lake Bled</highlight>, Hotel Kompas blends alpine charm with modern comfort. It offers five air-conditioned meeting rooms with natural light and spectacular views, as well as a lakeside restaurant and a panoramic café terrace for both business and informal gatherings. </p>
            <p>With 95 comfortable rooms, wellness facilities (pool, sauna, fitness, massage, squash), and walking distance to the lake and castle, it is <highlight>an ideal all-in-one conference venue.</highlight> As the official conference hotel, we recommend Hotel Kompas as the preferred accommodation for conference participants.</p>
            <p><highlight>Special room rates and priority booking</highlight> are available for attendees. The room rate includes access to selected wellness facilities such as swimming pool and fitness area. Guests staying between the 6th and 9th can use <a href="https://reservations.travelclick.com/102656?groupID=5080340" target="_blank" rel="noreferrer">this link</a>  to access the special discount. If you are arriving earlier or later, please contact the hotel directly (reservations@kompas-lovec.com) to arrange the discount. To ensure the correct rate is applied, please clearly state that you are attending the BPP conference.</p>
          </Col>
        </Row>
         <Row>
          <Col md="4"><Image src='images/venue-1.jpg' className="img-fluid mb-4" data-aos="fade-up" data-aos-delay="100"  /></Col>
          <Col md="4"><Image src='images/venue-2.jpg' className="img-fluid mb-4" data-aos="fade-up" data-aos-delay="200"  /></Col>
          <Col md="4"><Image src='images/venue-3.jpg' className="img-fluid mb-4" data-aos="fade-up" data-aos-delay="300"  /></Col>
          <Col md="4"><Image src='images/venue-4.jpg' className="img-fluid mb-4" data-aos="fade-up" data-aos-delay="400"  /></Col>
          <Col md="4"><Image src='images/venue-5.jpg' className="img-fluid mb-4" data-aos="fade-up" data-aos-delay="500"  /></Col>
          <Col md="4"><Image src='images/venue-6.jpg' className="img-fluid mb-4" data-aos="fade-up" data-aos-delay="600"  /></Col>
         </Row>
      </Container>

      

      <Container className='py-5'>
        <Row>
          <Col lg={{ span: 8, offset: 2 }} className='pb-5'>
            <h2 className='h1 mb-4 purple-h'>Travel & Transfers</h2>
            <p>Bled is <highlight>easily accessible by air, road, or rail.</highlight> The nearest international airport is Ljubljana Jože Pučnik Airport (LJU), located about 35 km from Bled (30–40 minutes by car). Several regional airports also provide convenient options.</p>
            <h3  className='mt-5'>Nearby Airports</h3>
            <ul>
              <li>Ljubljana Jože Pučnik Airport (LJU) – 35 km (≈ 30–40 min)</li>
              <li>Klagenfurt Airport (KLU), Austria – 65 km (≈ 1 hr)</li>
              <li>Trieste Airport (TRS), Italy – 170 km (≈ 2 hrs)</li>
              <li>Zagreb Airport (ZAG), Croatia – 200 km (≈ 2 hrs 15 min)</li>
              <li>Venice Marco Polo Airport (VCE), Italy – 280 km (≈ 3 hrs)</li>
            </ul>
            <p>Most major European cities offer direct flights to at least one of these airports.</p>

            <h3 className='mt-5'>From Ljubljana to Bled</h3>
            <p>If arriving via Ljubljana Airport or Ljubljana city, <highlight>several options are available to reach Bled.</highlight></p>

            <h5>GoOpti Shuttle</h5>
            <ul>
              <li>Reliable, affordable, and available from any of the airports listed above.</li>
              <li>Participants may benefit from exclusive transfer discounts arranged through our partner service.</li>
              <li>For shorter distances, we recommend using <a href="http://goop.tl/yoe1p" target="_blank" rel='noreferrer'>this link</a> to receive a <highlight>€5 discount</highlight>, which provides greater savings on lower transfer fares. You may also enter the code <highlight>RFLI32N16H97</highlight> when completing your booking.</li>
              <li>For longer distances, it is more advantageous to use the <highlight>8% discount</highlight> through <a href="http://goop.tl/yoe1p" target="_blank" rel='noreferrer'>this link</a></li>
            </ul>

            <h5>Bus from Ljubljana</h5>
            <ul>
              <li>Regular departures from Ljubljana Bus Station to Bled (approx. 1h 20min)</li>
              <li>Tickets available online or at the station</li>
              <li>Bled bus station is within walking distance of the venue</li>
            </ul>

            <h5>Train to Lesce-Bled Station</h5>
            <ul>
              <li>Trains run from Ljubljana to Lesce-Bled (≈ 50 min)</li>
              <li>From there, take a local bus or taxi to Bled (4 km)</li>
            </ul>

            <h5>Taxi or Private Transfer</h5>
            <ul>
              <li>Direct transfer from Ljubljana or the airport</li>
              <li>Approximate cost: €45–60 (Ljubljana Airport to Bled)</li>
            </ul>

          </Col>
          
        </Row>
      </Container>
      <Footer />
    </>
  );
}
 